import { createGlobalStyle } from 'styled-components'

// Keep this file as small as possible.

const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 62.5%;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    color: #333;
  }
  
  body {
    font-family: "Gilroy", Arial, sans-serif;
    height: 100%;
    color: #333;
  }

  #root {
    height: 100%;
  }

  ul {
    margin-left: 3rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

`

export default GlobalStyle
